<template>
  <div class="pa-10">
    <v-card class="mt-2">
      <v-row class="px-2">
        <v-col cols="12">
          <UserManagementDataTable />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import UserManagementDataTable from "@/components/Utils/UserManagementDataTable.vue";
export default {
  components: { UserManagementDataTable },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),

  created() {
    // console.log("created");
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
      // location.reload();
    }
  },
  methods: {},
};
</script>

<style></style>
